import { render, staticRenderFns } from "./AutoPostDepositsModal.vue?vue&type=template&id=00b58f6f&scoped=true&"
import script from "./AutoPostDepositsModal.vue?vue&type=script&lang=js&"
export * from "./AutoPostDepositsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b58f6f",
  null
  
)

export default component.exports